import {
  OtherIncome,
  OtherIncomeActionType,
} from 'src/components/Loan/Application/Sections/IncomeInfo/Inputs/OtherIncomes/store/types';

type OtherIncomeStore = OtherIncome[];

const defaultState: OtherIncomeStore = [];

const reducer = (
  state: OtherIncomeStore = defaultState,
  { type, data }: { type: OtherIncomeActionType; data: any },
): OtherIncomeStore => {
  switch (type) {
    // @ts-ignore
    case 'clear_loan_data':
      return defaultState;
    case OtherIncomeActionType.SET: {
      const items = [...state];
      for (const item of data) {
        const matchIndex = state.findIndex((x) => x.id === item.id);
        if (matchIndex > -1) {
          items.splice(matchIndex, 1, {
            ...items[matchIndex],
            ...item,
          });
        } else {
          items.push(item);
        }
      }
      return items;
    }
    case OtherIncomeActionType.UPDATE: {
      const matchIndex = state.findIndex((x) => x.id === data.id);
      const items = [...state];

      items.splice(matchIndex, 1, {
        ...items[matchIndex],
        ...data,
      });
      return items;
    }
    case OtherIncomeActionType.ADD: {
      const items = [...state, data];
      return items;
    }
    case OtherIncomeActionType.DELETE: {
      const matchIndex = state.findIndex((x) => x.id === data);
      const items = [...state];
      items.splice(matchIndex, 1);
      return items;
    }
    default:
      return state;
  }
};

export default reducer;
